module.exports = __webpack_public_path__ + "static/media/20ECE3.ae07378a.jpg";